import { Injectable } from '@angular/core';

import { Store } from '@ngrx/store';
import { SearchboxService, SearchConfig, StateWithProduct } from '@spartacus/core';

import { DpSearchService } from './search.service';

@Injectable()
export class DpSearchboxService extends SearchboxService {
  constructor(
    store: Store<StateWithProduct>,
    private readonly dpSearchService: DpSearchService
  ) {
    super(store);
  }

  search(query: string, searchConfig?: SearchConfig): void {
    super.search(this.formatQuery(query), searchConfig);
  }

  searchSuggestions(query: string, searchConfig?: SearchConfig): void {
    super.searchSuggestions(this.formatQuery(query), searchConfig);
  }

  private formatQuery(query: string): string {
    return this.dpSearchService.escapeTerm(query);
  }
}
